import React, { useState, useEffect } from 'react';

function ListIcon(props)
{
    const [color, setColor] = useState('#638CA3');

    useEffect(() => {
        if(props.isActive) {
            setColor('#FFFFFF')
        } else if(props.theme !== 'Dark') {
            setColor('#ABBCC5');
        } else {
            setColor('#638CA3');
        }
    }, [props.isActive, props.theme]);

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <path fill={color} d="M4 18a.968.968 0 0 1-.713-.288A.964.964 0 0 1 3 17c0-.283.096-.521.288-.713A.964.964 0 0 1 4 16c.283 0 .521.096.713.288.192.192.288.43.287.712a.968.968 0 0 1-.288.713A.964.964 0 0 1 4 18Zm0-5a.968.968 0 0 1-.713-.288A.964.964 0 0 1 3 12c0-.283.096-.521.288-.713A.964.964 0 0 1 4 11c.283 0 .521.096.713.288.192.192.288.43.287.712a.968.968 0 0 1-.288.713A.964.964 0 0 1 4 13Zm0-5a.968.968 0 0 1-.713-.288A.964.964 0 0 1 3 7c0-.283.096-.521.288-.713A.964.964 0 0 1 4 6c.283 0 .521.096.713.288.192.192.288.43.287.712a.968.968 0 0 1-.288.713A.964.964 0 0 1 4 8Zm3 10v-2h14v2H7Zm0-5v-2h14v2H7Zm0-5V6h14v2H7Z" />
        </svg>
    );
}

export default ListIcon;